export default {
    config: {
        icon: 'language',
        defaultWidth: 80
    },
    default: {
        label: 'Language Independance'
    },
    unique: [],
    sort: 'language.dependency',
    lang: {
        name: 'Language Independance',
        category: 'BGG',
        description: 'How independant of text are the game components.',
        views: ['list', 'sheet', 'grid'],
    },
    filters: ['language.independance', 'language.votes']
}